module.exports = __webpack_public_path__ + "img/help_center.7e311773.svg";